<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2023-09-11 13:53:54
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-13 16:09:12
 * @FilePath: \plantingSubsidy_web_update\src\views\statistics-charts\insurance-statistics\components\v1\TotalStatistics\index.vue
 * @Description: 承保一张图 —— 投保农户情况
-->
<template>
  <div class="chart_box">
    <!-- 左侧统计 -->
    <div class="left">
      <div class="item">
        <h1 style="color:#2af5ff"> {{statisticNum.personCount||0}}<span class="unit">户</span></h1>
        <p>投保总户数</p>
      </div>
    </div>
    <!-- 右侧统计 -->
    <div class="right">
      <!-- 项目1 -->
      <div class="item">
        <div class="img_box">
          <img src="../../../images/decor2.png" />
          <span>水稻政策性保险</span>
        </div>
        <div class="info_box">
          <h2> {{statisticRice.personCount}}<span class="unit">户</span></h2>
          <p>投保户数</p>

        </div>

      </div>

      <!-- 项目2 -->
      <div class="item">
        <div class="img_box">
          <img src="../../../images/decor2.png" />
          <span>玉米政策性保险</span>
        </div>
        <div class="info_box">
          <h2> {{statisticCorn.personCount}}<span class="unit">户</span></h2>
          <p>投保户数</p>

        </div>

      </div>
      <!-- 项目3 -->
      <div class="item">
        <div class="img_box">
          <img src="../../../images/decor2.png" />
          <span>大豆政策性保险</span>
        </div>
        <div class="info_box">
          <h2> {{statisticBean.personCount}}<span class="unit">户</span></h2>
          <p>投保户数</p>

        </div>

      </div>
      <!-- 项目4 -->
      <div class="item">
        <div class="img_box">
          <img src="../../../images/decor2.png" />
          <span>小麦政策性保险</span>
        </div>
        <div class="info_box">
          <h2> {{statisticWheat.personCount}}<span class="unit">户</span></h2>
          <p>投保户数</p>

        </div>

      </div>

    </div>

  </div>

</template>
<script>
// import moment from 'moment'
export default {
  props: {
    year: {
      type: String,
      default: ''

    }
  },
  data () {
    return {
      account: {}, // 当前用户
      statisticNum: {}, // 统计总户数
      statisticType: [] // 统计各类政策保险投保户数及面积
    }
  },
  computed: {
    /*  统计水稻 */
    statisticRice () {
      let num = {
        personCount: 0
      }

      if (this.statisticType.length > 0 && this.statisticType[0] && this.statisticType[0].personCount > 0) {
        num.personCount = this.statisticType[0].personCount
      }
      return num
    },

    // statisticRice&&(Number(statisticRice.cbAcreage/10000).toFixed(2))||0

    /*  统计玉米 */
    statisticCorn () {
      let num = {
        personCount: 0,
        cbAcreage: 0
      }
      let cbAcreage = 0
      if (this.statisticType.length > 0 && this.statisticType[1] && this.statisticType[1].cbAcreage > 0) {
        cbAcreage = (this.statisticType[1].cbAcreage / 10000).toFixed(2)
        num.cbAcreage = cbAcreage
      }
      if (this.statisticType.length > 0 && this.statisticType[1] && this.statisticType[1].personCount > 0) {
        num.personCount = this.statisticType[1].personCount
      }
      return num
    },

    /*  统计大豆 */
    statisticBean () {
      let num = {
        personCount: 0,
        cbAcreage: 0
      }

      let cbAcreage = 0

      if (this.statisticType.length > 0 && this.statisticType[2] && this.statisticType[2].cbAcreage > 0) {
        cbAcreage = (this.statisticType[2].cbAcreage / 10000).toFixed(2)
        num.cbAcreage = cbAcreage
      }
      if (this.statisticType.length > 0 && this.statisticType[2] && this.statisticType[2].personCount > 0) {
        num.personCount = this.statisticType[2].personCount
      }
      return num
    },
    /*  统计小麦 */
    statisticWheat () {
      let num = {
        personCount: 0,
        cbAcreage: 0
      }
      let cbAcreage = 0
      if (this.statisticType.length > 0 && this.statisticType[3] && this.statisticType[3].cbAcreage > 0) {
        cbAcreage = (this.statisticType[3].cbAcreage / 10000).toFixed(2)
        num.cbAcreage = cbAcreage
      }
      if (this.statisticType.length > 0 && this.statisticType[3] && this.statisticType[3].personCount > 0) {
        num.personCount = this.statisticType[3].personCount
      }
      return num
    }

  },

  created () {
    this.account = this.$store.state.account
    // 获取统计
    this.getMapByPlantType()
  },
  methods: {
    getMapByPlantType () {
      // this.$get('/statisticsBase/getMapByPlantType', {
      this.$get('/statistics/statisticsBase/getMapByPlantType', {
        province: this.account.user.province || '230000000000',
        city: this.account.userArea.city || '',
        county: this.account.userArea.county || '',
        // year: moment().format('YYYY')
        year: this.year
      })
        .then(r => {
          let data = r.data.data
          if (data.length <= 0) {
            this.statisticNum = {

              personCount: 0
            }
            this.statisticType = [{
              personCount: 0
            }, {
              personCount: 0
            }, {
              personCount: 0
            }, {
              personCount: 0
            }]

            return
          }
          // 取每个险种及合计信息
          let statisticType = []
          data.map(item => {
            if (item.plantTypeName.indexOf('水稻') != -1) {
              statisticType[0] = item
            } else if (item.plantTypeName.indexOf('玉米') != -1) {
              statisticType[1] = item
            } else if (item.plantTypeName.indexOf('大豆') != -1) {
              statisticType[2] = item
            } else if (item.plantTypeName.indexOf('小麦') != -1) {
              statisticType[3] = item
            }
          })
          this.statisticType = statisticType
          // 统计总户数及总面积

          let statisticNum = {

            personCount: statisticType.reduce((prev, cur) => cur.personCount + prev, 0)
          }
          this.statisticNum = statisticNum
        })
        .catch(e => {
          console.log('err:', e)
        })
    }

  },
  watch: {
    year: {

      handler (newVal) {
        this.getMapByPlantType()
      }
    }

  }

}
</script>
<style  lang="less" scoped>
.chart_box {
  display: flex;
  // width: 510px !important;
}
.left {
  display: flex;
  flex-direction: column;
  align-items: center;

  .item {
    width: 130px;
    padding-bottom: 10px;
    // &:nth-child(2n) {
    margin-bottom: 20px;
    // }
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url(../../../images/decor3.png) no-repeat 100%;
    background-position: center bottom;
    text-align: center;
    h1 {
      color: #fff;
      font-size: 22px;
      font-family: numFont;
      letter-spacing: 1px;
      margin-bottom: 0;
    }
    .unit {
      font-size: 14px;
    }
    p {
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: bold;
    }
  }
}
.right {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: no-wrap;
  .item {
    display: flex;
    align-items: center;
    width: 50%;
    height: 50%;
    margin-bottom: 10px;
    box-sizing: border-box;
    // padding: 10px;
    .img_box {
      position: relative;
      display: flex;
      font-weight: bold;
      padding-left: 10px;
      padding-right: 10px;
      img {
        width: 100px;
        flex-shrink: 0;
      }
      span {
        display: block;
        position: absolute;
        width: 4em;
        top: 15px;
        left: 62px;
        line-height: 19px;
        font-size: 14px;
      }
    }
    .info_box {
      flex: 1;
      text-align: center;
      padding-left: 1rem;
      line-height: 1.5em;
      p {
        color: rgba(255, 255, 255, 0.6);
        margin: 0;
        font-size: 12px;
      }
    }
    h2 {
      color: #fff;
      font-family: numFont;
      letter-spacing: 1px;
      font-size: 20px;
      margin: 0;
      white-space: nowrap;
    }
    .unit {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/TotalStatistics/index.vue